import graphixImge1 from "../../assets/img/gp1.png";
import graphixImge2 from "../../assets/img/gp2.png";
import graphixImge3 from "../../assets/img/gp3.png";
import graphixImge4 from "../../assets/img/gp4.png";
import graphixImge5 from "../../assets/img/gp5.png";
import graphixImge6 from "../../assets/img/gp6.png";
import graphixImge7 from "../../assets/img/gp7.png";
import graphixImge8 from "../../assets/img/gp8.png";
import graphixImge9 from "../../assets/img/gp9.png";
import graphixImge10 from "../../assets/img/gp10.png";
import graphixImge11 from "../../assets/img/gp11.png";
import graphixImge12 from "../../assets/img/gp12.png";
import graphixImge13 from "../../assets/img/gp13.png";
import graphixImge14 from "../../assets/img/gp14.png";
import graphixImge15 from "../../assets/img/gp15.png";



export const graphixLinks = [
    {
      title: "Game Cover Concept",
      description: "Design and Print",
      imgUrl: graphixImge1,
    },
    {
      title: "Concert Cover Concept",
      description: "Design and Print",
      imgUrl: graphixImge2,
    },
    {
      title: "Album Art",
      description: "Design and Print",
      imgUrl: graphixImge3,
    },
    {
      title: "Album Art",
      description: "Design and Print",
      imgUrl: graphixImge4,
    },
    {
      title: "Album Art",
      description: "Design and Print",
      imgUrl: graphixImge5,
    },
    {
      title: "Product Cover",
      description: "Design and Print",
      imgUrl: graphixImge6,
    },
    {
      title: "Concert Poster",
      description: "Design and Print",
      imgUrl: graphixImge7,
    },
    {
      title: "Album Art",
      description: "Design and Print",
      imgUrl: graphixImge8,
    },
    {
      title: "Album Art",
      description: "Design and Print",
      imgUrl: graphixImge9,
    },
    {
      title: "Flyer",
      description: "Design and Print",
      imgUrl: graphixImge10,
    },
    {
      title: "Album Art",
      description: "Design and Print",
      imgUrl: graphixImge11,
    },
    {
      title: "Flex Banner",
      description: "Design and Print",
      imgUrl: graphixImge12,
    },
    {
      title: "Poster",
      description: "Design and Print",
      imgUrl: graphixImge13,
    },
    {
      title: "Album Art",
      description: "Design and Print",
      imgUrl: graphixImge14,
    },
    {
      title: "Product Cover",
      description: "Design and Print",
      imgUrl: graphixImge15,
    },
    
    
  ];

  /*

import graphixImge16 from "../../assets/img/gp16.png";
import graphixImge17 from "../../assets/img/gp17.png";
import graphixImge18 from "../../assets/img/gp18.png";
import graphixImge19 from "../../assets/img/gp19.png";
import graphixImge20 from "../../assets/img/gp20.png";
import graphixImge21 from "../../assets/img/gp21.png";

    
    {
      title: "Concert Poster",
      description: "Design and Print",
      imgUrl: graphixImge16,
    },
    {
      title: "Movie Poster",
      description: "Design and Print",
      imgUrl: graphixImge17,
    },
    {
      title: "Album Art",
      description: "Design and Print",
      imgUrl: graphixImge18,
    },
    {
      title: "Flyer",
      description: "Design and Print",
      imgUrl: graphixImge19,
    },
    {
      title: "Book Cover",
      description: "Design and Print",
      imgUrl: graphixImge20,
    },
    {
      title: "Flex Banner",
      description: "Design and Print",
      imgUrl: graphixImge21,
    },

    */
